"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dracula = void 0;
const createColorScheme_1 = require("../createColorScheme");
exports.dracula = (0, createColorScheme_1.createColorScheme)("dracula", {
    bg: "#282a36",
    fg: "#b3b3b1",
    primary: "#FF2EA6",
    secondary: "#10F84B",
}, {
    red: "#ff5555",
    green: "#50fa7b",
    yellow: "#f1fa8c",
    blue: "#6272a4",
    purple: "#bd93f9",
    cyan: "#8be9fd",
    orange: "#ffb86c",
});
